import ScrollDiv from './component';

export default ScrollDiv;
